import { ModifyTreatmentMemoRequestPayload } from "@/data/payload/treatment/treatment-memo-mofity-request-payload";
import { TreatmentRepository } from "@/domain/repository/treatment-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class ModifyTreatmentMemoUsecase {
  //MARK:- Constructor
  constructor(private readonly treatmentRepo: TreatmentRepository) {}

  //MARK:- execute
  async execute(treatmentInfoUuid: string, memo: string): Promise<SATResult<void, SATError>> {
    const payload: ModifyTreatmentMemoRequestPayload = {
      treatmentInfoUuid,
      payload: { memo: memo },
    };

    const result = await this.treatmentRepo.modifyTreatmentMemo(payload);

    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return SATResult.success(void 0);
  }
}
